import { Avatar } from "shared/components/Avatar";
import { HeroHeadContainer } from "shared/components/HeroHead";
import { ImageContainer } from "shared/components/Image";
import { MaxWidth } from "shared/components/MaxWidth";
import { SMALL } from "shared/utils/constants";
import cx from "classnames";
import styles from "./Hero.module.css";

export const Hero = ({ type, title, lead, image, author, date, location }) => (
  <div className={cx(styles.container, { [styles.noImage]: !image?.url })}>
    <MaxWidth size={SMALL}>
      <div className={styles.content}>
        {(Boolean(date) || Boolean(location) || Boolean(type)) && (
          <HeroHeadContainer date={date} location={location} type={type} />
        )}

        <h1 className={styles.title}>{title}</h1>
        {author && (
          <div className={styles.author}>
            <Avatar {...author} />
          </div>
        )}
        {lead && <p className={styles.lead}>{lead}</p>}
      </div>
    </MaxWidth>

    {image?.url && (
      <div className={styles.image}>
        <ImageContainer
          alt={image.alt}
          caption={image.caption}
          credits={image.credits}
          size={image.size}
          src={image.url}
        />
      </div>
    )}
  </div>
);
